import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField
} from '@mui/material';
import { useFiles } from '../hooks/useFilesContext.js';

function CreateFolderModal({ open, onClose }) {
  const [folderName, setFolderName] = useState('');
  const { createFolder } = useFiles();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (folderName.trim()) {
      await createFolder(folderName.trim());
      setFolderName('');
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Nova Pasta</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nome da Pasta"
            type="text"
            fullWidth
            variant="outlined"
            value={folderName}
            onChange={(e) => setFolderName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="contained" disabled={!folderName.trim()}>
            Criar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default CreateFolderModal; 